<template>
  <div class="formCom">
    <div class="form" v-click-outside="closeConfurmModal">
      <button class="btn" @click="closeConfurmModal">
        <CloseIcone></CloseIcone>
      </button>
      <div class="name">
        Reason For Hold
      </div>
      <textarea
        class="input"
        placeholder="Type a Comment.."
        v-model="txt"
      ></textarea>
      <button class="saveBtn" @click="sendComment">Save</button>
      <div class="saveComment">{{ CommentTxt }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CloseIcone from "../../images/shared/cancel";

export default {
  props: ["txtOnHold"],
  data() {
    return {
      kit: null,
      CommentTxt: "",
      txt: ""
    };
  },
  components: {
    CloseIcone
  },
  methods: {
    ...mapActions(["sendNewData"]),
    sendComment() {
      const data = {
        kit_id: this.kit.kit_id,
        collected_first_name: this.kit.collected_first_name,
        collected_last_name: this.kit.collected_last_name,
        status: this.kit.status,
        indoor_samples: this.kit.indoorSamples,
        reason_on_hold: this.txt
      };
      this.sendNewData({ data, id: this.kit.id }).then(res => {
        this.CommentTxt = "Comment successfully saved";
      });
    },
    closeConfurmModal() {
      this.$emit("closeConfurmHoldTxt", false);
    }
  },
  mounted() {
    this.kit = this.$store.getters.getTestKitInfo;
    this.txt = this.txtOnHold.txt;
  }
};
</script>

<style scoped>
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 25px;
  background-color: #fff;
  max-width: 397px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.input {
  resize: none;
  height: 150px;
  padding: 15px 20px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  border: 1px solid #e4e4e4;
  outline: none;
  border-radius: 2px;
}
.input::placeholder {
  color: #98a4ae;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 15px;
  outline: none;
  height: 15px;
  background-color: transparent;
}
.btn img {
  max-width: 100%;
  height: 100%;
}
.saveBtn {
  outline: none;
  border: 1px solid transparent;
  color: #fff;
  width: 250px;
  height: 45px;
  margin: 25px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #62b039;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.saveComment {
  color: green;
  margin: 10px 0 0 0;
  text-align: center;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
</style>
